import api from "../../../../services/api";

export const getUserList = async (params = {}) => {
  const { 
    page = 1, 
    page_size = 20, 
    search, 
    order_by = "createdAt", 
    order_direction = "DESC",
    tenantUuid,
    tenant_uuid,
  } = params;

  try {
    const tenantId = tenant_uuid || tenantUuid;

    const orderByMap = {
      createdAt: "createdAt",
      fullName: "fullName",
      updatedAt: "updatedAt",
      created_at: "createdAt",
      full_name: "fullName",
      updated_at: "updatedAt",
      email: "email",
      status: "status",
    };

    const mappedOrderBy = orderByMap[order_by] || order_by;
    const normalizedOrderDirection = String(order_direction).toUpperCase();

    const body = {
      page,
      page_size,
      order_by: mappedOrderBy,
      order_direction: normalizedOrderDirection,
    };

    // Add tenant_uuid as independent field (snake_case)
    if (tenantId) {
      body.tenantUuid = tenantId;
    }

    // Add search parameter if exists
    if (typeof search === "string" && search.trim() !== "") {
      body.search = { keyword: search.trim() };
    } else if (search?.keyword && String(search.keyword).trim() !== "") {
      body.search = { keyword: String(search.keyword).trim() };
    }

    const response = await api.post("/v1/user/list", body);
    
    // Return response data
    return response.data;
  } catch (error) {
    console.error("Error fetching users from API, falling back to mock:", error);
    
    // ==================================================================================
    // TODO: REMOVE THIS ENTIRE FALLBACK BLOCK ONCE BACKEND IS FULLY READY AND STABLE
    // This mock fallback is only for development purposes when backend is unavailable
    // DELETE FROM HERE ↓
    // ==================================================================================
    try {
      const response = await fetch("/mock-users-list.json");
      const data = await response.json();
      
      // Filter by search
      let filteredUsers = [...data.body];
      
      if (search && search.trim() !== "") {
        const searchLower = search.toLowerCase();
        filteredUsers = filteredUsers.filter(user =>
          (user.fullName && user.fullName.toLowerCase().includes(searchLower)) ||
          (user.email && user.email.toLowerCase().includes(searchLower)) ||
          (user.roles && user.roles.length > 0 && 
           user.roles.some(role => role.roleName.toLowerCase().includes(searchLower)))
        );
      }
      
      const orderByForMock = order_by === "created_at" ? "createdAt" 
                          : order_by === "full_name" ? "fullName"
                          : order_by === "updated_at" ? "updatedAt"
                          : order_by;
      
      filteredUsers.sort((a, b) => {
        let aVal = a[orderByForMock];
        let bVal = b[orderByForMock];
        
        if (orderByForMock === "createdAt" || orderByForMock === "updatedAt") {
          aVal = new Date(aVal).getTime();
          bVal = new Date(bVal).getTime();
        } else if (typeof aVal === 'string') {
          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
        }
        
        if (order_direction === "ASC") {
          return aVal > bVal ? 1 : -1;
        } else {
          return aVal < bVal ? 1 : -1;
        }
      });
      
      // Paginate
      const startIndex = (page - 1) * page_size;
      const endIndex = startIndex + page_size;
      const paginatedUsers = filteredUsers.slice(startIndex, endIndex);
      
      return {
        statusCode: 200,
        msgCode: data.msg_code,
        requestId: data.request_id,
        body: paginatedUsers,
        meta: {
          totalItems: filteredUsers.length,
          totalPages: Math.ceil(filteredUsers.length / page_size),
          currentPage: page,
          perPage: page_size,
          hasNext: endIndex < filteredUsers.length,
          hasPrevious: page > 1,
          nextCursor: null,
        },
      };
    } catch (mockError) {
      console.error("Error fetching users from mock:", mockError);
      throw new Error("Failed to fetch users data from both API and mock");
    }
    // ==================================================================================
    // DELETE UP TO HERE ↑
    // After deleting, replace with: throw new Error("Failed to fetch users data");
    // ==================================================================================
  }
};

